import EnableAutoPay from '../../../../banking/components/cards/EnableAutoPay';

export default function EnableAutoPayPage() {
    return <EnableAutoPay />;
}
